import React, { useEffect, useRef, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  FormControl,
  MenuItem,
  ThemeProvider,
  Typography,
  createTheme,
  Select,
  Modal,
  Tabs,
  Tab,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
  TextField,
  IconButton,
} from "@mui/material";
import { Delete, Edit, Search } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import {
  BASE_URl,
  decodeToken,
  getApiCall,
  MAIN_URL,
  postApiCall,
  postFormApiCall,
  token,
} from "../../../utils/api";
import tableIcons from "../../component/MaterialIcon";
import EditStudents from "../modal/EditStudents";
import stateList from "../../../data/states.json";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Individual from "../modal/addstudenttabs/individual";
import Bulk from "../modal/addstudenttabs/bulk";
import { Download } from "@mui/icons-material";

const Students = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const [data, setData] = useState([]);
  const [bannerName, setBannerName] = useState("");

  const [bannerId, setBannerId] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const imageFileInputRef = useRef(null);

  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    fetchData();
  }, []);

  const [loggedUser, setLoggedUser] = useState({});
  const fetchData = async () => {
    setLoading(true);
    const resData = await decodeToken();
    setLoggedUser(resData.user);
    const res = await getApiCall("admin/get-all-students");
    // console.log(res.data);

    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("id", bannerId);
    formData.append("name", bannerName);
    formData.append("status", isChecked);
    formData.append("banner_img", imageFile);

    let res = {};
    if (bannerId === "") {
      res = await postFormApiCall("banner/add", formData);
    } else {
      res = await postFormApiCall("banner/update", formData);
    }
    setLoading(false);

    if (res.error === true) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = "";
    }

    setBannerId("");
    setBannerName("");
    setImageFile(null);
    fetchData();
  };

  const handleToggleRegister = async (rowData) => {
    try {
      const newStatus = !rowData.registered_for_olympiad; // toggle true/false
      const res = await postApiCall("admin/update-student-olypiad", {
        id: rowData.id,
        status: newStatus,
      });

      if (res.success) {
        setData((prevData) =>
          prevData.map((item) =>
            item.id === rowData.id
              ? { ...item, registered_for_olympiad: newStatus }
              : item,
          ),
        );
        Swal.fire("Success", res.message, "success");
      } else {
        Swal.fire("Error", res.message, "error");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const ChangeSchool = async (rowData) => {
    try {
      Swal.fire({
        title: "Change School",
        text: "Enter new School ID",
        icon: "warning",
        input: "number", // ⬅ input field
        inputPlaceholder: "School ID",
        inputAttributes: {
          min: 1,
        },
        showCancelButton: true,
        confirmButtonText: "Yes, Change",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",

        // 🔒 Validate input
        inputValidator: (value) => {
          if (!value) {
            return "School ID is required!";
          }
          if (isNaN(value)) {
            return "School ID must be a number";
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          const school_id = Number(result.value);

          const res = await postApiCall("admin/change-student-school", {
            student_id: rowData.id,
            school_id,
          });

          if (res.success === false) {
            return Swal.fire({
              title: "Error",
              text: res.message,
              icon: "error",
            });
          }

          Swal.fire({
            title: "Successful",
            text: res.message,
            icon: "success",
          });

          fetchData();
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Completed: {studentDetails.completed_count}
  //               <br /> Not Completed: {studentDetails.not_completed_count}

  const [detailOpen, setDetailOpen] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const [logsData, setLogsData] = useState([]);
  const [progressLogs, setProgressLogs] = useState([]);
  const [moduleCount, setModuleCount] = useState({});
  let logColumn = [
    { title: "Module", field: "module_name" },
    { title: "Activity Type", field: "content_type" },
    {
      title: "Activity Started",
      field: "started_at",
      render: (rowData) => {
        if (!rowData.started_at) return "N/A";
        const date = new Date(rowData.started_at);
        return (
          <div>
            {date.toLocaleDateString("en-GB")}
            <br />
            {date.toLocaleTimeString()}
          </div>
        );
      },
    },
    {
      title: "Activity Completed",
      field: "ended_at",
      render: (rowData) => {
        if (!rowData.ended_at) return "N/A";
        const date = new Date(rowData.ended_at);
        return (
          <div>
            {date.toLocaleDateString("en-GB")}
            <br />
            {date.toLocaleTimeString()}
          </div>
        );
      },
    },
  ];
  let progressLogColumn = [
    { title: "Module", field: "module_name" },
    {
      title: "Module Started",
      field: "created_at",
      render: (rowData) => {
        if (!rowData.created_at) return "N/A";
        const date = new Date(rowData.created_at);
        return (
          <div>
            {date.toLocaleDateString("en-GB")}
            <br />
            {date.toLocaleTimeString()}
          </div>
        );
      },
    },
    {
      title: "Progress",
      field: "levels",
      render: (rowData) => {
        if (!rowData.levels || rowData.levels.length === 0) {
          return "Not Started";
        }
        return rowData.levels?.map((level, index) => (
          <div key={index}>
            <span>
              {level.name}: {level.completed ? "✅" : "❌"}
            </span>
            <br />
          </div>
        ));
      },
    },
  ];

  const handleViewStudentdetails = async (rowData) => {
    const res = await postApiCall("get-details-data-student", {
      id: rowData.id,
    });

    if (res.success === true) {
      setStudentDetails(res.data);
      setLogsData(res.data.accesslogs);
      setProgressLogs(res.data.modules);
      setModuleCount(res.data.moduleCompletionCount);
      setDetailOpen(true);
    }
  };

  const handleViewAnalyticsSchool = (rowData) => {
    const url = `/schoolanalytics?id=${
      rowData.school_id
    }&name=${encodeURIComponent(rowData.schoolname)}`;

    window.open(url, "_blank", "noopener,noreferrer");
    // navigate("/schoolanalytics", {
    //   state: {
    //     id: rowData.school_id,
    //     name: rowData.schoolname,
    //   },
    // });
  };
  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Name",
      field: "name",
      render: (rowData) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span
              onClick={() => {
                handleViewStudentdetails(rowData);
              }}
              style={{
                color: "#1976d2",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {rowData.name}
            </span>
          </div>
        );
      },
    },
    { title: "Grade", field: "class" },
    { title: "Email", field: "email" },
    { title: "Phone", field: "parent_phone" },
    { title: "Student Phone", field: "phone" },
    {
      title: "School",
      field: "schoolname",
      render: (rowData) => {
        return (
          <>
            <div
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => handleViewAnalyticsSchool(rowData)}
            >
              {rowData.schoolname}
            </div>
            <button
              onClick={() => ChangeSchool(rowData)}
              className="btn btn-primary btn-small"
            >
              Change
            </button>
          </>
        );
      },
    },
    // {
    //   title: "Is Archived",
    //   field: "is_deleted",
    //   render: (rowData) => {
    //     return <>{rowData.is_deleted === true ? "Yes" : "No"}</>;
    //   },
    // },
    {
      title: "Register for Olympiad",
      field: "registered_for_olympiad",
      render: (rowData) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span>{rowData.registered_for_olympiad ? "Yes" : "No"}</span>
            <button
              onClick={() => handleToggleRegister(rowData)}
              className="btn btn-primary btn-small"
            >
              {rowData.registered_for_olympiad ? "Unregister" : "Register"}
            </button>
          </div>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const handleEdit = async (rowData) => {
    setRowData(rowData);
    setOpen(true);
  };

  const [schoolList, setSchoolList] = useState([]);
  const [schollFilterName, setSchollFilterName] = useState("");

  const handleUpdate = async (updatedData) => {
    setOpen(false);
    const res = await postApiCall("admin/update-students-details", updatedData);
    setRowData(null);

    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text:
          res.message + "\n" + res.error.map((err) => err.message).join("\n"),
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    fetchData();
  };
  const [cityList, setCityList] = useState([]);
  const [filterData, setFiterData] = useState({
    state: "",
    city: "",
  });
  const [allData, setAllData] = useState([]);

  const handleChange = async (event) => {
    setSchoolList([]);
    setData([]);
    setLoading(true);
    setSchollFilterName("");
    const { name, value } = event.target;
    const updatedFilterData = {
      ...filterData,
      [name]: value,
    };
    if (name === "state") {
      const selectedState = stateList.states.find(
        (state) => state.state_code === value,
      );
      setCityList(selectedState ? selectedState.cities : []);
      updatedFilterData.city = "";
    }
    setFiterData(updatedFilterData);
    const res = await postApiCall(
      `admin/student/filterByStateAndCity`,
      updatedFilterData,
    );
    if (res.data.length > 0) {
      const schoolNames = res.data.map((item) => item.schoolname);
      setSchoolList(schoolNames);
    }

    setLoading(false);

    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setAllData(res.data);
  };

  useEffect(() => {
    if (schollFilterName) {
      const filtered = allData.filter(
        (item) => item.schoolname === schollFilterName,
      );
      setData(filtered);
    } else {
      setData(allData); // 🟢 Restore all data if school filter is cleared
    }
  }, [schollFilterName, allData]);
  const navigate = useNavigate();
  const handleViewAnalytics = (rowData) => {
    const url = `/studentanalytics?id=${
      rowData.id
    }&name=${encodeURIComponent(rowData.name)}`;

    window.open(url, "_blank", "noopener,noreferrer");

    // navigate("/studentanalytics", {
    //   state: {
    //     id: rowData.id,
    //     name: rowData.name,
    //   },
    // });
  };

  const [isOpen, setIsOpen] = useState(false);
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
  };
  const searchClick = async (searchText) => {
    const result = await getApiCall(
      `admin/search-students?search=${searchText}`,
    );
    // console.log(result);
    setData(result.data);
    result.data.forEach((data, index) => {
      data.serial = index + 1;
    });
  };
  const downloadAllStudent = async () => {
    setLoading(true);
    const result = await getApiCall(`admin/download-all-students`);
    setLoading(false);
    downloadCSV(result.data);
  };

  const downloadCSV = (data, fileName = "students.csv") => {
    if (!data || !data.length) return;

    // Add serial number at the beginning
    const cleanedData = data.map((row, index) => {
      const { tableData, ...rest } = row; // remove material-table metadata if any
      return {
        serial: index + 1,
        ...rest,
      };
    });

    const csv = Papa.unparse(cleanedData);

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDelete = async (rowData) => {
    new Swal({
      title: "Are you sure? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("student/delete", {
          student_id: rowData.id,
          role: "admin",
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };
  return (
    <div>
      <Modal open={detailOpen} onClose={() => setDetailOpen(false)}>
        <Box
          sx={{
            ...style,
            width: "60%",
            // maxWidth: "800px",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ mb: 3, fontWeight: "bold" }}
          >
            Student Details
          </Typography>

          {studentDetails ? (
            <>
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: 1, color: "#2280e6ff" }}
                >
                  Basic Information
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Name:</strong> {studentDetails.name}
                    </Typography>
                    <Typography>
                      <strong>Class:</strong> {studentDetails.class}
                    </Typography>
                    <Typography>
                      <strong>Email:</strong> {studentDetails.email}
                    </Typography>
                    <Typography>
                      <strong>Score:</strong> {studentDetails.score}
                    </Typography>
                    <Typography>
                      <strong>Is Deleted?:</strong>{" "}
                      {studentDetails.is_deleted ? "Yes" : "No"}
                    </Typography>
                    <Typography>
                      <strong>City:</strong> {studentDetails.city || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Pincode:</strong>{" "}
                      {studentDetails.pincode || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Preferred Language:</strong>{" "}
                      {studentDetails.preferred_language}
                    </Typography>
                    <Typography>
                      <strong>Last Login:</strong>{" "}
                      {new Date(studentDetails.last_login_at).toLocaleString(
                        "en-GB",
                      )}
                    </Typography>
                    <Typography>
                      <strong>Registered for Olympiad:</strong>{" "}
                      {studentDetails.registered_for_olympiad ? "Yes" : "No"}
                    </Typography>
                    <Typography>
                      <strong>Created On:</strong>{" "}
                      {new Date(studentDetails.created_at).toLocaleString(
                        "en-GB",
                      )}
                    </Typography>
                    <Typography>
                      <strong>Last Updated:</strong>{" "}
                      {new Date(studentDetails.updated_at).toLocaleString(
                        "en-GB",
                      )}
                    </Typography>
                  </Grid>
                </Grid>

                <hr />
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#2280e6ff" }}
                >
                  School Information
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>School Name:</strong>
                      <span
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                        onClick={() =>
                          handleViewAnalyticsSchool(studentDetails)
                        }
                      >
                        {studentDetails.schoolname}
                      </span>
                    </Typography>

                    {/* <Typography>
                      <strong>School Name:</strong> {studentDetails.schoolname}
                    </Typography> */}
                    <Typography>
                      <strong>School Type:</strong> {studentDetails.schooltype}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Description:</strong>{" "}
                      {studentDetails.schooldescription || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Start Road Safety Club?:</strong>{" "}
                      {studentDetails.startRoadSafetyClub || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Address:</strong>{" "}
                      {studentDetails.schooladdress || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>

                <hr />
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#2280e6ff" }}
                >
                  Parent Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Parent Name:</strong> {studentDetails.parentname}
                    </Typography>
                    <Typography>
                      <strong>Parent Email:</strong>{" "}
                      {studentDetails.parentemail}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Parent Phone:</strong>{" "}
                      {studentDetails.parentphone}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <hr />

              <ThemeProvider theme={defaultMaterialTheme}>
                <MaterialTable
                  icons={tableIcons}
                  title="Access Logs"
                  columns={logColumn}
                  data={logsData}
                  onRowClick={(evt, selectedRow) =>
                    setSelectedRow(selectedRow.tableData.id)
                  }
                  options={{
                    exportButton: true,
                    pageSizeOptions: [5, 20, 100],
                    exportCsv: (columns, data) => {
                      // Get ALL KEYS from the first row (all fields)
                      const allKeys = Object.keys(data[0] || {}).filter(
                        (key) => key !== "tableData", // remove tableData
                      );

                      // Serial should be first
                      const finalFields = ["serial", ...allKeys];

                      // Titles (capitalize keys)
                      const columnTitles = finalFields.map((key) =>
                        key === "serial"
                          ? "Serial"
                          : key.replace(/_/g, " ").toUpperCase(),
                      );

                      // Build rows
                      const csvData = data.map((row, index) =>
                        finalFields.map((field) => {
                          if (field === "serial") return index + 1;
                          return row[field] ?? "";
                        }),
                      );

                      // Convert to CSV
                      const csv = Papa.unparse({
                        fields: columnTitles,
                        data: csvData,
                      });

                      // Download
                      const blob = new Blob([csv], {
                        type: "text/csv;charset=utf-8;",
                      });
                      const link = document.createElement("a");
                      link.href = URL.createObjectURL(blob);
                      link.setAttribute("download", "logs.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    },

                    exportPdf: (columns, data) => {
                      const doc = new jsPDF();
                      const tableColumnTitles = columns.map((col) => col.title);
                      const tableRows = data.map((row) =>
                        columns.map((col) => row[col.field] ?? ""),
                      );

                      autoTable(doc, {
                        head: [tableColumnTitles],
                        body: tableRows,
                        styles: { fontSize: 8 },
                        headStyles: { fillColor: [0, 123, 255] },
                      });

                      doc.save("logs.pdf");
                    },
                    actionsColumnIndex: -1,
                    headerStyle: {
                      backgroundColor: "rgb(0 123 255)",
                      color: "#FFF",
                      fontSize: 18,
                    },
                    cellStyle: {
                      fontSize: "14px", // 🔹 smaller row font
                    },
                    rowStyle: (rowData, index) => ({
                      backgroundColor:
                        selectedRow === rowData.tableData.id
                          ? "#d3d4d1"
                          : index % 2 !== 0
                            ? "#EEE"
                            : "#FFF",
                    }),
                  }}
                  components={{}}
                />
              </ThemeProvider>

              <hr />
              <ThemeProvider theme={defaultMaterialTheme}>
                <MaterialTable
                  icons={tableIcons}
                  title={
                    <div>
                      <div style={{ fontSize: 20, fontWeight: "bold" }}>
                        Module Progress
                      </div>
                      <div style={{ fontSize: 14, color: "gray" }}>
                        Completed: {moduleCount?.completed_count ?? 0} /
                        Pending: {moduleCount?.not_completed_count ?? 0}
                      </div>
                    </div>
                  }
                  columns={progressLogColumn}
                  data={progressLogs}
                  onRowClick={(evt, selectedRow) =>
                    setSelectedRow(selectedRow.tableData.id)
                  }
                  options={{
                    exportButton: true,
                    pageSizeOptions: [5, 20, 100],
                    exportCsv: (columns, data) => {
                      // Extract column titles
                      const columnTitles = columns.map((col) => col.title);

                      // Build CSV rows
                      const csvData = data.map(
                        (row) => columns.map((col) => row[col.field] ?? ""), // handle undefined fields
                      );

                      // Combine into a full CSV
                      const csv = Papa.unparse({
                        fields: columnTitles,
                        data: csvData,
                      });

                      // Create and trigger file download
                      const blob = new Blob([csv], {
                        type: "text/csv;charset=utf-8;",
                      });
                      const url = URL.createObjectURL(blob);
                      const link = document.createElement("a");
                      link.href = url;
                      link.setAttribute("download", "logs.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    },
                    exportPdf: (columns, data) => {
                      const doc = new jsPDF();
                      const tableColumnTitles = columns.map((col) => col.title);
                      const tableRows = data.map((row) =>
                        columns.map((col) => row[col.field] ?? ""),
                      );

                      autoTable(doc, {
                        head: [tableColumnTitles],
                        body: tableRows,
                        styles: { fontSize: 8 },
                        headStyles: { fillColor: [0, 123, 255] },
                      });

                      doc.save("logs.pdf");
                    },
                    actionsColumnIndex: -1,
                    headerStyle: {
                      backgroundColor: "rgb(0 123 255)",
                      color: "#FFF",
                      fontSize: 18,
                    },
                    cellStyle: {
                      fontSize: "14px", // 🔹 smaller row font
                    },
                    rowStyle: (rowData, index) => ({
                      backgroundColor:
                        selectedRow === rowData.tableData.id
                          ? "#d3d4d1"
                          : index % 2 !== 0
                            ? "#EEE"
                            : "#FFF",
                    }),
                  }}
                  components={{}}
                />
              </ThemeProvider>
            </>
          ) : (
            <Typography variant="h6" gutterBottom>
              Data not available
            </Typography>
          )}

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <button
              className="btn btn-primary"
              variant="contained"
              onClick={() => setDetailOpen(false)}
              sx={{ mt: 2 }}
            >
              Close
            </button>
          </Box>
        </Box>
      </Modal>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" gutterBottom>
            Add Student
          </Typography>
          <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Individual" />
            <Tab label="Bulk" />
          </Tabs>

          <Box sx={{ mt: 2 }}>
            {tab === 0 && (
              <Individual setIsOpen={setIsOpen} fetchData={fetchData} />
            )}
            {tab === 1 && <Bulk setIsOpen={setIsOpen} fetchData={fetchData} />}
          </Box>
        </Box>
      </Modal>
      {rowData && (
        <EditStudents
          key={rowData?.id}
          open={open}
          onClose={() => setOpen(false)}
          rowData={rowData}
          onUpdate={handleUpdate}
        />
      )}
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => setIsOpen(true)}
              >
                + Add Student
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="content mt-3">
        <div className="container-fluid">
          {loggedUser.role == "admin" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <button
                aria-label="search"
                className="btn btn-success"
                onClick={() => downloadAllStudent()}
              >
                <Download /> Download All Student
              </button>
              <div>
                <TextField
                  variant="standard"
                  placeholder="Search Student"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <IconButton
                  aria-label="search"
                  onClick={() => searchClick(searchText)}
                >
                  <Search />
                </IconButton>
              </div>
            </div>
          )}
          <ThemeProvider theme={defaultMaterialTheme}>
            <MaterialTable
              icons={tableIcons}
              title=""
              columns={columns}
              data={data}
              // data={async (query) => {
              //   const result = await getApiCall(
              //     `admin/search-students?search=${query.search}&page=${query.page}&pageSize=${query.pageSize}&state=${filterData.state}&city=${filterData.city}&school=${schollFilterName}`
              //   );
              //   console.log(`admin/search-students?search=${query.search}&page=${query.page}&pageSize=${query.pageSize}&state=${filterData.state}&city=${filterData.city}&school=${schollFilterName}`);

              //   // result.data.forEach((data, index) => {
              //   //   data.serial = index + 1;
              //   // });

              //   return {
              //     data: result.data,
              //     page: query.page,
              //     totalCount: result.totalCount,
              //   };
              // }}
              onRowClick={(evt, selectedRow) =>
                setSelectedRow(selectedRow.tableData.id)
              }
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 50, 100, 1000],
                search: false,
                exportButton: true,
                exportCsv: (columns, data) => {
                  // Create SERIAL + FULL DATA export
                  const cleanedData = data.map((row, index) => {
                    const { tableData, ...rest } = row; // remove tableData
                    return { serial: index + 1, ...rest }; // add serial at start
                  });

                  // Extract fields dynamically
                  const fields = Object.keys(cleanedData[0] || {});

                  // Generate CSV
                  const csv = Papa.unparse({
                    fields,
                    data: cleanedData.map((row) =>
                      fields.map((f) => row[f] ?? ""),
                    ),
                  });

                  // Download file
                  const blob = new Blob([csv], {
                    type: "text/csv;charset=utf-8;",
                  });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", "student.csv");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                },
                exportPdf: (columns, data) => {
                  const doc = new jsPDF();

                  // Prepare cleaned data
                  const cleanedData = data.map((row, index) => {
                    const { tableData, ...rest } = row;
                    return { serial: index + 1, ...rest };
                  });

                  const fields = Object.keys(cleanedData[0] || {});

                  const tableRows = cleanedData.map((row) =>
                    fields.map((f) => row[f] ?? ""),
                  );

                  autoTable(doc, {
                    head: [fields],
                    body: tableRows,
                    styles: { fontSize: 8 },
                    headStyles: { fillColor: [0, 123, 255] },
                  });

                  doc.save("student.pdf");
                },
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "rgb(0 123 255)",
                  color: "#FFF",
                  fontSize: 18,
                },
                rowStyle: (rowData, index) => ({
                  backgroundColor:
                    selectedRow === rowData.tableData.id
                      ? "#d3d4d1"
                      : index % 2 !== 0
                        ? "#EEE"
                        : "#FFF",
                }),
              }}
              components={{
                Toolbar: (props) => (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="10px"
                  >
                    {/* Left Side: Title */}
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      Students
                    </Typography>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {loggedUser.role == "admin" && (
                        <>
                          <FormControl
                            sx={{ width: "200px", marginRight: "16px" }}
                          >
                            <Select
                              sx={{ height: "40px" }}
                              name="state"
                              value={filterData.state}
                              onChange={handleChange}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select State
                              </MenuItem>
                              {stateList.states
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                                ?.map((state) => (
                                  <MenuItem
                                    key={state.state_code}
                                    value={state.state_code}
                                  >
                                    {state.name}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>

                          <FormControl
                            sx={{ width: "200px", marginRight: "16px" }}
                          >
                            <Select
                              sx={{ height: "40px" }}
                              name="city"
                              value={filterData.city}
                              onChange={handleChange}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select City
                              </MenuItem>
                              {cityList.map((city) => (
                                <MenuItem key={city} value={city}>
                                  {city}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <FormControl
                            sx={{ width: "200px", marginRight: "16px" }}
                          >
                            <Select
                              sx={{ height: "40px" }}
                              name="school"
                              value={schollFilterName}
                              onChange={(e) => {
                                setSchollFilterName(e.target.value);
                              }}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select School
                              </MenuItem>

                              {schoolList.map((school, index) => (
                                <MenuItem key={index} value={school}>
                                  {school}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      )}
                      <MTableToolbar {...props} />
                    </Box>
                  </Box>
                ),
              }}
              actions={[
                // View Analytics — visible to all users
                {
                  icon: () => (
                    <span style={{ color: "#009688" }}>
                      <i className="fas fa-chart-bar"></i>
                    </span>
                  ),
                  tooltip: "View Analytics",
                  onClick: (event, rowData) => handleViewAnalytics(rowData),
                },
                // Edit — only for admin
                ...(loggedUser.role === "admin"
                  ? [
                      {
                        icon: () => (
                          <span style={{ color: "#5656ce" }}>
                            <Edit />
                          </span>
                        ),
                        tooltip: "Edit",
                        onClick: (event, rowData) => handleEdit(rowData),
                      },
                      {
                        icon: () => (
                          <span style={{ color: "#5656ce" }}>
                            <Delete />
                          </span>
                        ),
                        tooltip: "Delete",
                        onClick: (event, rowData) => handleDelete(rowData),
                      },
                    ]
                  : []),
              ]}
            />
          </ThemeProvider>
        </div>
      </section>
    </div>
  );
};

export default Students;
